<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix modal-heading">
      <span>Constant Contact Integration Settings</span>
      <el-button
        type="text"
        @click="$modal.hide('tracker-constant-contact-form')"
      >
        <font-awesome-icon icon="window-close" fixed-width></font-awesome-icon>
      </el-button>
    </div>
    <el-form
      @submit.native.prevent="submit"
      :label-position="$root.windowWidth > 767 ? 'right' : 'top'"
      label-width="100px"
    >
      <el-form-item
        :error="form.errors.first('key') ? form.errors.first('key') : null"
        label="Key"
        required
      >
        <el-input
          v-model="data.key"
          type="text"
          @focus="form.errors.clear('key')"
        ></el-input>
        <p class="help-text">
          Follow steps three <strong><em>only</em></strong>
          <a href="https://constantcontact.mashery.com/" target="_blank"
            >here</a
          >
          and input the access token above.
        </p>
      </el-form-item>

      <el-button
        type="primary"
        plain
        medium
        native-type="submit"
        :style="{ width: '100%' }"
        v-loading="loading"
        :disabled="loading"
      >
        Submit
      </el-button>
    </el-form>
  </el-card>
</template>

<style scoped>
</style>

<script>
import Form from "form-backend-validation"
import { mapActions, mapGetters } from "vuex"

export default {
  name: "TrackerSiteimpactForm",

  mixins: [],
  components: {},

  props: {
    existing: {
      required: true,
    },
  },

  data() {
    return {
      data: {
        key: "",
      },
      form: new Form(),
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      company: "companies/current",
    }),
    action() {
      return "tracker/" + this.company.slug + "/constantcontact/update"
    },
  },
  watch: {},

  methods: {
    ...mapActions({
      updateCompany: "tracker/updateAdmin",
    }),
    submit() {
      this.loading = true

      let formData = {
        key: this.data.key,
      }

      this.axios
        .post(this.action, formData)
        .then((response) => {
          this.updateCompany(response.data.data)
          this.$message.success(response.data.message)
          this.$modal.hide("tracker-constant-contact-form")
          this.loading = false
        })
        .catch((resp) => {
          this.loading = false
          if (resp.response && resp.response.status === 422) {
            this.form.onFail(resp)
          } else {
            this.$root.globalRequestError(resp)
          }
        })
    },
  },

  created() {
    if (this.existing !== null) {
      this.data.key = this.existing
    }
  },
  mounted() {},
}
</script>
